export function extractAndSetDimensions() {
    const activeButton = document.querySelector('.valueofinput.active');

    if (activeButton) {
        const cardTitle = activeButton.getAttribute('card-title');

        if (cardTitle) {
            // Upravený regulárny výraz pre rozmery (200 x 300) a hmotnosť (25kg)
            const dimensions = cardTitle.match(/(\d+)\s*[\sx]\s*(\d+)\s*[\sx]?\s*(\d+)?|(\d+)\s*kg/);

            if (dimensions) {
                const width = parseFloat(dimensions[1]);  // Šírka tapety v mm (alebo undefined)
                const height = parseFloat(dimensions[2]); // Výška tapety v mm (alebo undefined)
                const weight = parseFloat(dimensions[4]); // Hmotnosť (v kg)

                // Nájdenie inputov pre rozmery alebo hmotnosť
                const inputWallWidth = document.getElementById('myInputWidth');
                const inputWallHeight = document.getElementById('myInputHeight');
                const inputArea = document.getElementById('myInputArea');
                const inputAreaM2 = document.getElementById('myInputAreaM2');

                // Ak existujú rozmery, počítame kusy
                if (!isNaN(width) && !isNaN(height)) {
                    if (inputWallWidth && inputWallHeight && inputArea && inputAreaM2) {
                        inputWallWidth.addEventListener('input', () => {
                            calculateRequiredPieces(width, height);
                            calculateArea();
                        });

                        inputWallHeight.addEventListener('input', () => {
                            calculateRequiredPieces(width, height);
                            calculateArea();
                        });

                        inputArea.addEventListener('input', () => {
                            calculatePiecesFromArea(width, height);
                        });

                        inputAreaM2.addEventListener('input', () => {
                            calculatePiecesFromM2(width, height);
                        });

                        // Prepočty
                        calculateRequiredPieces(width, height);
                        calculatePiecesFromM2(width, height);

                       // console.log(width, height)
                    }
                }

                // Ak existuje hmotnosť, počítame vrecia
                if (!isNaN(weight)) {
                   // console.log(weight)
                    const inputWeight = document.getElementById('myInputWeight');
                    const inputBags = document.getElementById('myInputBags');

                    // Skontrolujeme, či existujú inputy
                    if (inputWeight) {
                        inputWeight.value = weight; // Zobrazenie hmotnosti v inpute
                    }

                    if (inputBags) {
                        const totalBags = Math.ceil(weight / sackWeight); // Výpočet počtu vriec
                        inputBags.value = totalBags; // Nastavenie počtu vriec
                    }
                }
            } else {
               // console.warn("Nenašli sa žiadne čísla alebo hmotnosť v atribúte 'card-title'.");
            }
        } else {
           // console.warn("Atribút 'card-title' nebol nájdený.");
        }
    } else {
       // console.warn("Aktívne tlačidlo s triedou 'valueofinput' nebolo nájdené.");
    }
}


// Funkcia na výpočet plochy steny na základe šírky a výšky (inputy sú v cm)
function calculateArea() {
    const inputWallWidth = document.getElementById('myInputWidth');
    const inputWallHeight = document.getElementById('myInputHeight');
    const inputArea = document.getElementById('myInputArea'); // Input pre m²

    const wallWidth = parseFloat(inputWallWidth.value);
    const wallHeight = parseFloat(inputWallHeight.value);

    if (!isNaN(wallWidth) && !isNaN(wallHeight) && wallWidth > 0 && wallHeight > 0) {
        const wallArea = (wallWidth / 100) * (wallHeight / 100); // cm -> m²

        if (inputArea) {
            // Ak je plocha steny celé číslo, zobrazíme ho bez desatinných miest
            if (Number.isInteger(wallArea)) {
                inputArea.value = wallArea; // Zobrazí sa celé číslo
            } else {
                inputArea.value = wallArea.toFixed(2); // Inak zobrazíme s dvoma desatinnými miestami
            }
        }
    } else {
        if (inputArea) {
            inputArea.value = ''; // Resetovanie hodnoty plochy
        }
    }
}

// Funkcia na výpočet potrebného počtu kusov na základe šírky a výšky (v cm)
function calculateRequiredPieces(width, height) {
    const inputWallWidth = document.getElementById('myInputWidth');
    const inputWallHeight = document.getElementById('myInputHeight');
    const inputHowMuch = document.getElementById('myInputHowMuch');

    const wallWidth = parseFloat(inputWallWidth.value);
    const wallHeight = parseFloat(inputWallHeight.value);

    if (!isNaN(wallWidth) && !isNaN(wallHeight) && wallWidth > 0 && wallHeight > 0) {
        const tapetaArea = (width / 1000) * (height / 1000); // mm -> m²
        const wallArea = (wallWidth / 100) * (wallHeight / 100); // cm -> m²
        const howMany = Math.ceil(wallArea / tapetaArea);

        if (inputHowMuch) {
            inputHowMuch.value = howMany; // Nastaví počet kusov na základe rozmerov
        }
    } else {
        inputHowMuch.value = ''; // Reset hodnoty
    }
}

// Funkcia na výpočet kusov z m² (na základe vstupu myInputArea)
function calculatePiecesFromArea(width, height) {
    const inputArea = document.getElementById('myInputArea');
    const inputHowMuch = document.getElementById('myInputHowMuch');

    const area = parseFloat(inputArea.value);

    if (!isNaN(area) && area > 0) {
        const tapetaArea = (width / 1000) * (height / 1000); // mm -> m²
        const howMany = Math.ceil(area / tapetaArea); // Výpočet kusov z m²

        if (inputHowMuch) {
            inputHowMuch.value = howMany; // Výsledok kusov
        }
    } else {
        inputHowMuch.value = ''; // Reset hodnôt
    }
}

// Funkcia na výpočet kusov z m² (na základe vstupu myInputAreaM2)
function calculatePiecesFromM2(width, height) {
    const inputAreaM2 = document.getElementById('myInputAreaM2');
    const inputHowMuchM2 = document.getElementById('myInputHowMuchM2');

    const areaM2 = parseFloat(inputAreaM2.value);

    if (!isNaN(areaM2) && areaM2 > 0) {
        const tapetaArea = (width / 1000) * (height / 1000); // mm -> m²
        const howManyM2 = Math.ceil(areaM2 / tapetaArea); // Výpočet kusov z m²

        if (inputHowMuchM2) {
            inputHowMuchM2.value = howManyM2; // Výsledok kusov z m²
        }
    } else {
        if (inputHowMuchM2) {
            inputHowMuchM2.value = ''; // Reset hodnôt
        }
    }
}

// Pridanie event listenera pre myInputAreaM2 a myInputHowMuchM2
const inputAreaM2 = document.getElementById('myInputAreaM2');
const inputHowMuchM2 = document.getElementById('myInputHowMuchM2');

// Vymazanie hodnôt a prepočet pri zmene (oninput)
inputAreaM2.addEventListener('input', () => {
    inputHowMuchM2.value = ''; // Vymazanie hodnoty v myInputHowMuchM2

    const activeButton = document.querySelector('.valueofinput.active');

    if (activeButton) {
        const cardTitle = activeButton.getAttribute('card-title');
        const dimensions = cardTitle.match(/(\d+)\s*[\sx]\s*(\d+)\s*[\sx]?\s*(\d+)?/);

        if (dimensions) {
            const width = parseFloat(dimensions[1]);  // Šírka tapety v mm
            const height = parseFloat(dimensions[2]); // Výška tapety v mm

            calculatePiecesFromM2(width, height); // Prepočet kusov z m² po zmene hodnoty
        }
    }
});


// Vytvorenie event listenerov pre myInputWidth a myInputHeight na vymazanie hodnôt
const inputWallWidth = document.getElementById('myInputWidth');
const inputWallHeight = document.getElementById('myInputHeight');

inputWallWidth.addEventListener('input', () => {
    const inputArea = document.getElementById('myInputArea');
    const inputHowMuch = document.getElementById('myInputHowMuch'); // Input pre počet kusov

    inputArea.value = ''; // Vymazanie hodnoty v myInputArea
    inputHowMuch.value = ''; // Vymazanie hodnoty v myInputHowMuch
});

inputWallHeight.addEventListener('input', () => {
    const inputArea = document.getElementById('myInputArea');
    const inputHowMuch = document.getElementById('myInputHowMuch'); // Input pre počet kusov

    inputArea.value = ''; // Vymazanie hodnoty v myInputArea
    inputHowMuch.value = ''; // Vymazanie hodnoty v myInputHowMuch
});

// Funkcia na resetovanie inputov
function resetInputs() {
    // Získanie všetkých inputov, ktoré chcete resetovať
    const inputs = [
        document.getElementById('myInputWidth'),
        document.getElementById('myInputHeight'),
        document.getElementById('myInputArea'),
        document.getElementById('myInputHowMuch'),
        document.getElementById('myInputAreaM2'),
        document.getElementById('myInputHowMuchM2'),
        document.getElementById('myInputAreaM2omietka'),
        document.getElementById('myInputAreaHrubka'),
        document.getElementById('myInputAreaHrubkaKG'),
        document.getElementById('myInputHowMuchVriec')
    ];

    // Pre každý input resetujte jeho hodnotu
    inputs.forEach(input => {
        if (input) {
            input.value = ''; // Resetovanie na prázdny reťazec
        }
    });
}

// Pridajte event listener na ikonu resetCalculator
const resetCalculator = document.getElementById('resetCalculator');
if (resetCalculator) {
    resetCalculator.addEventListener('click', resetInputs);
}

// Hustota materiálu (napríklad omietky) v kg/m²/mm
const materialDensity = 1;  // Upravte podľa materiálu, napr. 1.6 kg/m²/mm
const sackWeight = 25; // Hmotnosť jedného vreca v kg (napr. 25 kg)

// Funkcia na výpočet hmotnosti a počtu vriec
function calculateWeightAndBags() {
    // Získanie vstupných hodnôt
    const areaM2 = parseFloat(document.getElementById('myInputAreaM2omietka').value);
    const thicknessMM = parseFloat(document.getElementById('myInputAreaHrubka').value);

    // Kontrola, či sú hodnoty správne zadané
    if (!isNaN(areaM2) && !isNaN(thicknessMM) && areaM2 > 0 && thicknessMM > 0) {
        // Výpočet celkovej hmotnosti (kg)
        const totalWeight = areaM2 * thicknessMM * materialDensity;

        // Nastavenie hodnoty do inputu pre hmotnosť
        document.getElementById('myInputAreaHrubkaKG').value = totalWeight.toFixed(2); // Zobrazenie na 2 desatinné miesta

        // Výpočet počtu vriec
        const totalBags = Math.ceil(totalWeight / sackWeight);

        // Nastavenie počtu vriec do inputu
        document.getElementById('myInputHowMuchVriec').value = totalBags;
    } else {
        // Resetovanie hodnôt, ak nie sú zadané správne hodnoty
        document.getElementById('myInputAreaHrubkaKG').value = '';
        document.getElementById('myInputHowMuchVriec').value = '';
    }
}

// Event listenery pre inputy, aby sa výpočet spustil pri zmene hodnôt
document.getElementById('myInputAreaM2omietka').addEventListener('input', calculateWeightAndBags);
document.getElementById('myInputAreaHrubka').addEventListener('input', calculateWeightAndBags);






